import createClass from 'create-react-class'
const React = require('react')

const i18n = require('live/services/i18n')

const ValidationMixin = require('live/components/forms/mixins/validation-mixin')
const ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')('/rest/extension', {
    type: 'etl',
    active: true,
    config: {
        cron: '',
        table: '',
        provider: '',
        collection: ''
    },
    fullQualifier: null,
    qualifier: null,
    status: {}
})

const FormBase = require('live/components/extensions/ui/form')

const FormGroup = require('live/components/forms/ui/form-group')

const Form = createClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {},
    render(): JSX.Element {
        const object = this.state.object
        const config = object.config

        return (
            <FormBase self={this}>
                <div className="form-area">
                    <h3>{i18n('Connection config')}</h3>

                    <FormGroup
                        type="text"
                        label={i18n('Provider')}
                        name="config.provider"
                        value={config.provider}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.provider')}
                        hasFeedback
                        help={this.errorsFor('config.provider')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('Table')}
                        name="config.table"
                        value={config.table}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.table')}
                        hasFeedback
                        help={this.errorsFor('config.table')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('Collection')}
                        name="config.collection"
                        value={config.collection}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.collection')}
                        hasFeedback
                        help={this.errorsFor('config.collection')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('Cron')}
                        name="config.cron"
                        value={config.cron}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.cron')}
                        hasFeedback
                        help={this.errorsFor('config.cron')}
                    />
                </div>
            </FormBase>
        )
    }
})

export default Form
